import { useCallback, useEffect, useState } from "react";

const KEY = "akil-portfolio-theme";

const initial = () => {
  if (typeof window === "undefined") return "light";
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch (e) {
    // private mode / storage disabled — fall through to the system preference
  }
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
};

// Theme lives as data-theme on <html>; every colour in the stylesheets reads
// from the custom properties scoped to it (see index.css).
export default function useTheme() {
  const [theme, setTheme] = useState(initial);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", theme === "dark" ? "#060912" : "#f6f8fc");
    try {
      window.localStorage.setItem(KEY, theme);
    } catch (e) {
      // ignore write failures
    }
  }, [theme]);

  const toggle = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return { theme, toggle };
}
